export const customerPrices = {
    customerTools: 370,
    gardenerTools: 407,
    gardenerLargeTools: 555,
};

export const gardenerPrices = {
    customerTools: 185,
    gardenerTools: 222,
    gardenerLargeTools: 370,
};

export const gardenerPricesIfVatLiable = {
    customerTools: 231.25,
    gardenerTools: 277.50,
    gardenerLargeTools: 370,
};
